// Per-tick rising-edge detector. Each `pressed(name, current)` returns true
// only on the tick where `current` flips false→true. Holding the key down
// returns true once, then false until released and pressed again.

export class EdgeBuffer<K extends string> {
  private readonly prev: Record<string, boolean> = {}

  constructor(keys: readonly K[]) {
    for (const k of keys) this.prev[k] = false
  }

  pressed(name: K, current: boolean): boolean {
    const rising = current && !this.prev[name]
    this.prev[name] = current
    return rising
  }

  reset(): void {
    for (const k of Object.keys(this.prev)) this.prev[k] = false
  }
}
